import {Type} from "class-transformer";
import {serializeType} from "./common";

export class DocFolder {
  id: number;
  name: string;
  @Type(serializeType(DocFolder)) docFolder: DocFolder;
}